var _rect, _rect2, _rect3, _circle, _path, _path2, _rect4, _rect5, _path3, _path4, _rect6, _rect7, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    viewBox: "0 0 236 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 57.7986,
    width: 91.6791,
    height: 36.3806,
    rx: 6.44433,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4255,
    y: 70.8955,
    width: 45.1119,
    height: 10.1866,
    rx: 5.09328,
    fill: "#A3BBD1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 105.821,
    width: 75.6716,
    height: 36.3806,
    rx: 6.44433,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.311,
    cy: 124.223,
    r: 10.0643,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7042 127.424L67.376 125.096C67.1144 124.834 66.6917 124.834 66.43 125.096C66.1683 125.358 66.1683 125.78 66.43 126.042L69.2346 128.847C69.4962 129.108 69.9189 129.108 70.1806 128.847L77.2793 121.748C77.541 121.486 77.541 121.064 77.2793 120.802C77.0176 120.54 76.5949 120.54 76.3333 120.802L69.7042 127.424Z",
    fill: "#003A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9324 70.4006H40.669C41.1055 70.4006 41.319 69.8767 41.0085 69.576L38.3018 66.879C38.1078 66.6946 37.807 66.6946 37.613 66.879L34.916 69.576C34.6055 69.8767 34.819 70.4006 35.2555 70.4006H36.9921V80.1215H35.2555C34.819 80.1215 34.6055 80.6454 34.916 80.9461L37.6227 83.6431C37.8167 83.8275 38.1175 83.8275 38.3115 83.6431L41.0182 80.9461C41.3287 80.6454 41.1055 80.1215 40.6787 80.1215H38.9324V70.4006Z",
    fill: "#003A70"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109.269,
    y: 105.821,
    width: 106.231,
    height: 36.3806,
    rx: 6.44433,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 145.649,
    y: 118.918,
    width: 42.2015,
    height: 10.1866,
    rx: 5.09328,
    fill: "#A3BBD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.547 130.706L118.847 131.249V122.489L116.49 128.174C116.092 129.163 116.567 130.298 117.547 130.706V130.706ZM136.465 127.116L131.653 115.504C131.352 114.776 130.644 114.33 129.897 114.31C129.645 114.31 129.383 114.349 129.131 114.456L121.981 117.415C121.253 117.716 120.807 118.414 120.787 119.161C120.778 119.423 120.826 119.685 120.933 119.937L125.745 131.55C126.046 132.287 126.764 132.733 127.52 132.743C127.773 132.743 128.025 132.695 128.267 132.598L135.408 129.639C136.397 129.231 136.873 128.096 136.465 127.116V127.116ZM122.737 120.131C122.204 120.131 121.767 119.695 121.767 119.161C121.767 118.627 122.204 118.191 122.737 118.191C123.271 118.191 123.708 118.627 123.708 119.161C123.708 119.695 123.271 120.131 122.737 120.131V120.131ZM120.797 130.803C120.797 131.87 121.67 132.743 122.737 132.743H124.144L120.797 124.652V130.803Z",
    fill: "#003A70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.694 122.204C196.433 122.464 196.433 122.884 196.694 123.144L199.755 126.206C200.015 126.466 200.435 126.466 200.695 126.206L203.757 123.144C204.017 122.884 204.017 122.464 203.757 122.204C203.497 121.944 203.077 121.944 202.816 122.204L200.222 124.792L197.634 122.204C197.374 121.944 196.947 121.95 196.694 122.204V122.204Z",
    fill: "#003A70"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 123.821,
    y: 57.7986,
    width: 91.6791,
    height: 36.3806,
    rx: 6.44433,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160.201,
    y: 70.8955,
    width: 43.6567,
    height: 10.1866,
    rx: 5.09328,
    fill: "#A3BBD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.147 76.2311L146.147 77.9676C146.147 78.4042 146.671 78.6176 146.972 78.3072L149.669 75.6005C149.853 75.4064 149.853 75.1057 149.669 74.9117L146.972 72.2146C146.671 71.9042 146.147 72.1176 146.147 72.5542L146.147 74.2908L136.426 74.2908L136.426 72.5542C136.426 72.1176 135.902 71.9042 135.602 72.2146L132.905 74.9214C132.72 75.1154 132.72 75.4161 132.905 75.6102L135.602 78.3169C135.902 78.6273 136.426 78.4042 136.426 77.9773L136.426 76.2311L146.147 76.2311Z",
    fill: "#003A70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7311 119.93H38.6383L36.9891 124.62H40.3804L38.7311 119.93Z",
    fill: "#003A70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6898 113.704C32.9999 113.704 28.382 118.322 28.382 124.012C28.382 129.702 32.9999 134.32 38.6898 134.32C44.3797 134.32 48.9976 129.702 48.9976 124.012C48.9976 118.322 44.3797 113.704 38.6898 113.704ZM41.7821 128.557L40.9781 126.269H36.4015L35.5871 128.557C35.4634 128.918 35.113 129.166 34.7316 129.166C34.0925 129.166 33.6493 128.527 33.876 127.929L37.3189 118.775C37.5353 118.208 38.0713 117.827 38.6898 117.827C39.298 117.827 39.8443 118.208 40.0607 118.775L43.5036 127.929C43.7303 128.527 43.2871 129.166 42.648 129.166C42.2563 129.166 41.9058 128.918 41.7821 128.557Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2Mob);
export default __webpack_public_path__ + "static/media/card2_mob.bf06c0e63d9baedef62050fc556e6715.svg";
export { ForwardRef as ReactComponent };